import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Observable, ObservableInput, of, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../models/app-config';
import { ConfigService } from './config.service';
import { AddressModel } from '../models/address';

@Injectable({
  providedIn: 'root',
})
export class AddressService {
    
    constructor(private configService: ConfigService, private httpClient: HttpClient) {}

    public getUtilityAccountAddressData(quoteRequestId: number, utilityAccountNumber: string): Observable<any> {
        const path = this.configService.getApiPath(`utility-information/utility-address/${quoteRequestId}/${utilityAccountNumber}`);
        return this.httpClient.get<any>(path);
    }


    public saveUtilityAccountAddressData(quoteRequestId: number, addressListModel: AddressModel[]): Observable<any> {
      const path = this.configService.getApiPath(`utility-information/utility-address/${quoteRequestId}`);
      return this.httpClient.post<any>(path, addressListModel);
  }
}
